export const getAidsList = (aids) => {
  if (!aids) return [];

  return aids
    .split(",")
    .map((a) => a.trim())
    .filter(Boolean);
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date)) return "N/A";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
